export const A5_ASSESSMENT_TYPE = "A5_AND_PHQ";
export const A5_V2_ASSESSMENT_TYPE = "A5_V2_AND_PHQ";
export const A5_SUB_ASSESSMENT_TYPE = "A5";
export const A5R_ASSESSMENT_TYPE = "A5-R";
export const DEFAULT_ASSESSMENT_TYPE = "DEFAULT";